import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import ZonaLandingImg from '../../../assets/img/zonademand.svg';
import ZonaLandingImgMobile from '../../../assets/img/zonademand_mobile.svg';
import ZonaLandingImgMX from '../../../assets/img/zonademand_MX_desktop.png';
import ZonaLandingImgMXMobile from '../../../assets/img/zonademand_MX_mobile.png';
import ZonaLandingImgMXTablet from '../../../assets/img/zonademand_MX_tablet.png';
import ZonaLandingImgUBMobile from '../../../assets/img/zonademand_UB_mobile.png';
import ZonaLandingImgUBTablet from '../../../assets/img/zonademand_UB_tablet.png';
import ZonaLandingImgUBDesktop from '../../../assets/img/zonademand_UB_destkop.png';

const siteId = process.env.REACT_APP_BUILD_SITE;
const getBackgroundHeader = device => {
  if (siteId === 'ZPAR') {
    if (device === 'mobile') return `url(${ZonaLandingImgMobile})`;
    if (device === 'tablet') return `url(${ZonaLandingImg})`;
    return `url(${ZonaLandingImg})`;
  }

  if (siteId === '24MX') {
    if (device === 'mobile') return `url(${ZonaLandingImgMXMobile})`;
    if (device === 'tablet') return `url(${ZonaLandingImgMXTablet})`;
    return `url(${ZonaLandingImgMX})`;
  }

  if (siteId === 'UBPE') {
    if (device === 'mobile') return `url(${ZonaLandingImgUBMobile})`;
    if (device === 'tablet') return `url(${ZonaLandingImgUBTablet})`;
    return `url(${ZonaLandingImgUBDesktop})`;
  }
  return null;
};

const Container = styled.div`
  height: ${({ device }) => {
    if (device === 'mobile') return '376px';
    if (device === 'tablet') return '319px';
    return '319px';
  }};
  width: 100%;
  background: black;
  position: relative;
  ::before {
    content: '';
    opacity: ${siteId === '24MX' ? '0.5' : '1'};
    background-repeat: no-repeat;
    background-position: ${siteId === '24MX' ? 'center' : 'bottom'};
    background-size: cover;
    background-image: ${({ device }) => getBackgroundHeader(device)};
    position: absolute;
    width: 100%;
    height: 100%;
  }
`;

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: ${({ device }) => {
    if (device === 'mobile') return '60px 0px';
    if (device === 'tablet') return '60px 0 0 90px';
    return '0';
  }};
  padding: ${({ device }) => {
    if (device === 'mobile') return '0px 14px';
    if (device === 'tablet') return '32px 0px 0px';
    return '40px 0px 0px';
  }};
  font-style: normal;
  @media (min-width: 1366px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        margin: 0px 0px 0px 90px;
      `}
  }
  @media (max-width: 820px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        margin-left: 18px;
      `}
  }
`;

const Title = styled.div`
  font-weight: 600;
  font-size: ${({ device }) => {
    if (device === 'mobile') return '22px';
    return '32px';
  }};
  line-height: 48px;
  text-align: center;
  color: ${select('white')};
  white-space: break-spaces;
  margin-bottom: 8px;
  text-shadow: gray 0px 4px 5px;
  position: relative;
  margin-top: ${({ device }) => {
    if (device === 'mobile') return '28px';
    return '0';
  }};
`;

const Subtitle = styled.div`
  font-weight: 400;
  font-size: ${({ device }) => {
    if (device === 'mobile') return '16px';
    return '18px';
  }};
  line-height: 24px;
  max-width: ${({ device }) => {
    if (device === 'mobile') return '376px';
    return '463px';
  }};
  text-align: center;
  color: ${select('white')};
  white-space: break-spaces;
  height: ${({ device }) => {
    if (device === 'tablet') return 'auto';
    return '78px';
  }};
  text-shadow: gray 0px 4px 5px;
  position: relative;
  margin-bottom: ${({ device }) => {
    if (device === 'mobile') return '56px';
    if (device === 'tablet') return '24px';
    return '0';
  }};
  @media (max-width: 375px) {
    ${({ device }) =>
      device === 'mobile' &&
      css`
        margin-bottom: 56px;
      `}
  }
`;

const CTA1 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 449px;
  height: 48px;
  color: ${select('white')};
  background: ${getColor('primary')};
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 130%;
  padding: 0px 12px;
  cursor: pointer;
  position: relative;
  margin-bottom: ${({ device }) => {
    if (device === 'mobile') return '8px';
    if (device === 'tablet') return '8px';
    return '0';
  }};
  :hover {
    background-color: ${getColor('primaryHover')};
  }
`;

const CTA2 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 449px;
  height: 48px;
  background: ${select('white')};
  border: 1px solid ${getColor('primary')};
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 130%;
  padding: 0px 12px;
  cursor: pointer;
  position: relative;
  :hover {
    background-color: ${siteId === 'UBPE' ? getColor('tertiary') : select('orangeLight')};
  }
`;

export { Container, ContentBox, Title, Subtitle, CTA1, CTA2 };
